/* eslint-disable spire/fenced-imports */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import setWorkOrder from "@tKgpco/Store/Data/CheckoutReviewAndSubmit/Handlers/WorkOrderHandler";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    const cartState: any = getCurrentCartState(state).value;
    return {
        cartState,
        workOrderNumber: state.KGPState.CheckoutReview.workOrder,
        isAwaitingApproval: cartState?.isAwaitingApproval,
    };
};

const mapDispatchToProps = {
    setWorkOrder,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CheckoutShippingCarrierServiceStyles {
    workOrderGrid?: GridItemProps;
}

export const checkoutShippingCarrierServiceStyles: CheckoutShippingCarrierServiceStyles = {
    workOrderGrid: {
        width: 12,
        css: css`
            padding: 0px 5px 20px 16px;
            label {
                font-size: ${TYPOGRAPHY.size.smallest};
            }
        `,
    },
};

/**
 * @deprecated Use checkoutShippingCarrierServiceStyles instead.
 */
export const checkoutShippingCarrierService = checkoutShippingCarrierServiceStyles;
const styles = checkoutShippingCarrierServiceStyles;

const WorkOrderNumber: FC<Props> = ({ setWorkOrder, cartState, workOrderNumber, isAwaitingApproval }) => {
    const [workOrderValue, setWorkOrderValue] = useState(
        cartState?.properties?.workOrderNumber || workOrderNumber || "",
    );
    useEffect(() => {
        setWorkOrder({ workOrder: workOrderValue });
    }, [workOrderValue]);

    return (
        <GridContainer>
            {/* Custom Work Order Number -- start */}
            <GridItem {...styles.workOrderGrid}>
                <TextField
                    label={translate("Work Order#")}
                    value={workOrderValue}
                    onChange={e => {
                        setWorkOrderValue(e.currentTarget.value);
                    }}
                    disabled={isAwaitingApproval}
                />
            </GridItem>

            {/* Custom Work Order Number -- End */}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(WorkOrderNumber),
    definition: {
        displayName: "Work Order Number",
        group: "Checkout - Review & Submit",
        allowedContexts: [CheckoutReviewAndSubmitPageContext],
    },
};

export default widgetModule;
